export default function NewsUpdates() {
  return <div className="text-center mt-12">Under Construction</div>;
}
